var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2916 5.30078H14.885V9.51946H17.2916V5.30078Z",
    fill: "#82AA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6675 7.70703H10.6378V10.1423H13.6675V7.70703Z",
    fill: "#82AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0732 4.73242H10.0435V6.54452H13.0732V4.73242Z",
    fill: "#82AA00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1445 2.72989H16.4106L13.6807 0L10.9508 2.72989H9.21692C8.60941 2.72989 8.11401 3.22267 8.11401 3.83279V11.0682C8.11401 11.6757 8.6068 12.1711 9.21692 12.1711H18.1471C18.7546 12.1711 19.25 11.6783 19.25 11.0682V3.83279C19.2474 3.22267 18.7546 2.72989 18.1445 2.72989ZM13.6807 1.29063L15.1199 2.72989H12.2414L13.6807 1.29063ZM18.1262 11.0734H9.23517V3.82497H18.1262V11.0734Z",
    fill: "#82AA00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3029 6.51631V3.93457H2.58174V6.51631H0V8.23747H2.58174V10.8192H4.3029V8.23747H6.88464V6.51631H4.3029Z",
    fill: "#82AA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassified);
export default __webpack_public_path__ + "static/media/classified.9aa349e23cf9c3fe5c59010aa2c13251.svg";
export { ForwardRef as ReactComponent };